/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Sex_HelperInputs */

const en_us2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only used to estimate loads and energy use. Nobody else sees it.`)
};

const pt_br2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos só para estimar carga e gasto de energia. Ninguém mais vê.`)
};

const es_419_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se usa para estimar cargas y gasto de energía. Nadie más lo ve.`)
};

const pt_pt2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos só para estimar a carga e o gasto de energia. Mais ninguém vê.`)
};

const fr_fr2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sert uniquement à estimer les charges et la dépense d'énergie. Personne d'autre ne le voit.`)
};

const de_de2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird nur zur Schätzung von Gewichten und Energieverbrauch genutzt. Niemand sonst sieht es.`)
};

const it_it2_profile_editors_sex_helper = /** @type {(inputs: Profile_Editors_Sex_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo usiamo solo per stimare carichi e consumo energetico. Nessun altro lo vede.`)
};

/**
* | output |
* | --- |
* | "Only used to estimate loads and energy use. Nobody else sees it." |
*
* @param {Profile_Editors_Sex_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_sex_helper = /** @type {((inputs?: Profile_Editors_Sex_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Sex_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_sex_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_sex_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_sex_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_sex_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_sex_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_sex_helper(inputs)
	return en_us2_profile_editors_sex_helper(inputs)
});
export { profile_editors_sex_helper as "profile-editors.sex_helper" }